<!-- 批量导入弹框 -->
<template>
  <el-dialog :visible.sync="dialogVisible" width="25%" center>
    <p class="p1">新增收货地址</p>
    <el-input placeholder="收货人姓名 (请使用真实姓名)"></el-input>
    <el-input placeholder="手机号码"></el-input>
    <el-input placeholder="所在地区"></el-input>
    <el-input placeholder="街道、小区门牌等详细地址"></el-input>
    <div class="ridioBox">
        <el-checkbox  v-model="checked">设为默认地址</el-checkbox>
        <el-button class="btns" type="primary">新增收获地址</el-button>
    </div>
    <div class="line"></div>
    <span slot="footer" class="dialog-footer">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="10">
</el-pagination>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
       dialogVisible: false,
       checked: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    init() {
      this.dialogVisible = true;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .el-input__inner {
    background: #F2F2F2;
    color: black;
    border: none;
    margin-bottom: 0.1rem;
}
/deep/ .el-checkbox__inner {
    border-radius: 50%;
}
/deep/ .el-checkbox__input {
    transform: scale(1.5);
}
.p1 {
  font-size: 0.16rem;
  color: #000;
  font-weight: bold;
  margin-bottom: 0.24rem;
}
.ridioBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.1rem;
    .btns {
        color: white;
        background: #F6390D;
        border-radius: 100px;
        cursor: pointer;
    }
}
.line {
    height: 1px;
    border-bottom: 1px solid #BBBBBB;
}
</style>
